/**
 * @name Main
 * @description Main Layout (Contenedor principal con Topbar y Sidebar)
 * @author Ricardo Guerra
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

// React Router
import { Redirect } from 'react-router-dom';

import { Topbar } from '@components';
import { AuthService, PreviousRouteService } from '@services';
import { Layout } from '@styles';

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adminActions: [],
      sidebarActions: []
    };
  }

  componentDidMount() {
    const { history } = this.props.children.props;
    const isAuth = AuthService.authentication.isAuth;

    if (!localStorage.getItem('ls.infoUsuario') || !localStorage.getItem('ls.authorizationData') || !isAuth) {
      //PreviousRouteService.saveRouteFromExpiredSession('talentry/#/home', 'talentry/#/');
      history.push("/login");
    }
  }

  render() {
    const { children } = this.props;

    return (
      <>
        {!(!localStorage.getItem('ls.infoUsuario') || !localStorage.getItem('ls.authorizationData')) ? (
          <Layout.MainWrapper>
            <Topbar
              showBackButton={this.props.backButton}
              showSidebar={this.props.sidebar}
              adminActions={this.state.adminActions}
              sidebarActions={this.state.sidebarActions}
              {...children.props}
            />
            <Layout.ContentWrapper>
              {children}
            </Layout.ContentWrapper>
          </Layout.MainWrapper>
        ) : (
          null
        )}
      </>
    );
  }
}

Main.propTypes = {
  children: PropTypes.node,
  backButton: PropTypes.bool,
  sidebar: PropTypes.bool,
};

export default Main;